module.exports = __webpack_public_path__ + "0021e52156c852a918c229adba98f7e8.svg";